import React, { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api } from "@/lib/api";
const PremiumContext = createContext(null);
export function PremiumProvider({ children }) {
  const { user } = useAuth();
  const [catalog, setCatalog] = useState(null);
  const [error, setError] = useState(false);
  const revision = useRef(0);
  const refresh = useCallback(async () => {
    const current = ++revision.current;
    try {
      const { data } = await api.get("/premium/catalog");
      if (current === revision.current) { setCatalog(data); setError(false); }
      return data;
    } catch (_) { if (current === revision.current) setError(true); return null; }
  }, []);
  useEffect(() => {
    setCatalog(null); setError(false); refresh();
    return () => { revision.current += 1; };
  }, [user?.id, user?.role, refresh]);
  useEffect(() => {
    const recover = () => { if (!document.hidden) refresh(); };
    const timer = setInterval(recover, 60000);
    document.addEventListener("visibilitychange", recover);
    window.addEventListener("dayone:premium-required", recover);
    return () => { clearInterval(timer); document.removeEventListener("visibilitychange", recover); window.removeEventListener("dayone:premium-required", recover); };
  }, [refresh]);
  return <PremiumContext.Provider value={{ catalog, error, refresh, loading: !catalog && !error, access: true }}>{children}</PremiumContext.Provider>;
}
export const usePremium = () => useContext(PremiumContext) || { catalog: null, loading: false, error: false, access: true, refresh: () => {} };
